import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { AboutServiceWrapStyle, AboutServiceInner } from './about-service-wrap.style'

const AboutServiceWrap = ({ children }) => {
    const imageData = useStaticQuery(graphql`
        query ABoutServiceImageQuery {
            file(relativePath: {eq: "images/bg/synergenie-home-infotechno-section-company-bg.png"}) {
                childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, width: 428, quality: 75)
                }
            }
        }      
    `)
    return (
        <AboutServiceWrapStyle>
            <AboutServiceInner>
                <GatsbyImage
                    image={imageData.file.childImageSharp.gatsbyImageData}
                    alt=""
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                    imgStyle={{ objectFit: "none", objectPosition: "left 140px" }}
                />
            </AboutServiceInner>
            <div style={{ position: "relative", zIndex: 1 }}>
                {children}
            </div>
        </AboutServiceWrapStyle>)
}

AboutServiceWrap.propTypes = {
    children: PropTypes.node.isRequired
}

export default AboutServiceWrap; 